// import { useParams } from "react-router-dom";
import {useDispatch} from 'react-redux'
import "../CSS/userProfile.css"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure
} from '@chakra-ui/react'
import { logout } from '../Redux/action'
const UserProfile = () =>{
    // let {id} = useParams();
    const dispatch = useDispatch()
const Logout =()=>{
    dispatch(logout())
}

    function BasicUsage() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button colorScheme='white' color='black' onClick={onOpen}>Logout</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            Are you wnat logout?
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              No
            </Button>
            <Button variant='ghost' onClick={Logout}>Yes</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
    
    return (
        <div className="container">
            <h1>User Information</h1>
            <div className="box">
                <div className="controls">
                    <div>Personal Information</div>
                    <div>Order History</div>
                    <div>Your Wishlist</div>
                    <div>{BasicUsage()}</div>
                </div>
                <div className="information">
                    hello
                </div>
            </div>
            
        </div>
    )
}

export default UserProfile